<template>
  <div class="payment-failed">
    <div class="failed-icon">
        <fa icon="exclamation-circle" />
    </div>
    <h1>Something went wrong</h1>
    <p>{{ error }}</p>
    <el-button type="danger" class="ok-button" @click="$emit('close')">OK</el-button>
  </div>
</template>

<script>
export default {
  name: 'PaymentFailed',
  props: {
    error: String
  }
}
</script>

<style lang="scss" scoped>
  .payment-failed {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .failed-icon {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      background-color: $red;
      color: white;
      border-radius: 100%;
      width: 100px;
      height: 100px;

      svg {
        position: relative;
        bottom: -20px;
        font-size: 96px;
      }
    }

    .ok-button {
      width: 100px;
      margin-top: 40px;
    }

    h1 {
      color: $red;
      margin-top: 40px;
      margin-bottom: 5px;
    }

    p {
      font-size: 14px;
      color: $text-light;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/payment-state/Failed.vue